document.addEventListener('DOMContentLoaded', () => {
  const popups = document.querySelectorAll('.popup-section');
  if (!popups.length) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let scheduled = false;

  function updatePosition() {
    scheduled = false;
    const offset = reducedMotion.matches ? 0 : -window.scrollY * 0.03;
    popups.forEach((popup) => {
      popup.style.transform = `translateY(${offset}px)`;
      popup.style.transition = reducedMotion.matches ? 'none' : 'transform 0.3s ease-out';
    });
  }

  window.addEventListener('scroll', () => {
    if (scheduled || reducedMotion.matches) return;
    scheduled = true;
    window.requestAnimationFrame(updatePosition);
  }, { passive: true });

  reducedMotion.addEventListener('change', updatePosition);
  updatePosition();
});
